export default "dist/images/block-image-box-box.aadb69d.png";